import { render, staticRenderFns } from "./MyConsultantConversation.vue?vue&type=template&id=b8fb839e&"
import script from "./MyConsultantConversation.vue?vue&type=script&lang=js&"
export * from "./MyConsultantConversation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports